
/**
 * 异步延迟
 * @param ms 延迟时间（毫秒）
 * @param data 需要传递进来的参数，起到类似闭包的作用
 */
export default function delay<T = any> (ms: number, data?: T): Promise<T | void> {
  return new Promise((resolve) => {
    const timeID = setTimeout(() => {
      clearTimeout(timeID)
      resolve(data)
    }, ms)
  })
}
